<template>
  <div class="details">
    <h4 class="text-center">VITAMINA B1 (TIAMINA)</h4>
    <p>
      As principais fontes de vitamina B1 são: legumes e cereais integrais e leguminosas como feijão e grão de bico. Ela é importante para produção de ácido clorídrico e para a formação do sangue, além de ter importante função no metabolismo dos carboidratos.<br/><br/>
      A absorção da vitamina B1 é prejudicada com o consumo elevado de álcool. A deficiência da vitamina B1 no organismo pode causar fraqueza muscular, falta de energia, diminuição da memória e depressão. Uma deficiência extremamente acentuada, o que é mais comum em pacientes alcoólatras, pode causar a doença beribéri, resultando em fraqueza muscular, problemas gastro-intestinais e dificuldades respiratórias.
    </p>
  </div>
</template>
